import { render, staticRenderFns } from "./productsProfit.vue?vue&type=template&id=4d951121&scoped=true&"
import script from "./productsProfit.vue?vue&type=script&lang=js&"
export * from "./productsProfit.vue?vue&type=script&lang=js&"
import style0 from "./productsProfit.vue?vue&type=style&index=0&id=4d951121&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d951121",
  null
  
)

export default component.exports